import { useAutoApprovedQualifications } from "@src/appV2/Licenses/useAutoApprovedQualifications";
import { ALL_QUALIFICATIONS_CATEGORY } from "@src/appV2/Qualifications/Categories/constants";
import { useGetQualificationsByCategories } from "@src/appV2/Qualifications/Categories/useGetQualificationsByCategories";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";
import { useRef } from "react";

export function useAddRolesData() {
  const workerQualifications = useWorkerQualifications();
  const autoApprovedQualifications = useAutoApprovedQualifications();

  const {
    data: qualificationsByCategories,
    isLoading: qualificationsAreLoading,
    isSuccess: qualificationsAreLoaded,
    isError: qualificationsAreError,
  } = useGetQualificationsByCategories();

  const { userId: workerId, shoppableQualifications } = useDefinedWorker();

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const workerQualificationIds = workerQualifications.data?.map((q) => q.id) ?? [];

  return {
    allQualifications: qualificationsByCategories?.[ALL_QUALIFICATIONS_CATEGORY] ?? [],
    qualificationsByCategories: qualificationsByCategories ?? {
      [ALL_QUALIFICATIONS_CATEGORY]: [],
    },
    qualificationsAreLoading,
    qualificationsAreLoaded,
    qualificationsAreError,
    autoApprovedQualifications,
    workerId,
    scrollContainerRef,
    workerQualificationIds,
    shoppableQualifications,
  };
}
